import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import SearchComponent from '../common/SearchComponent';

class PaymentsSearchForm extends SearchComponent {
  searchInputs = [
    {
      label: 'common:label.type',
      name: 'type',
      type: 'select',
      tOptions: 'selections:transactionType',
      isClearable: true,
    },
    {
      label: 'common:label.itemId',
      name: 'itemId',
    },
    {
      label: 'common:label.startDate',
      name: 'startDate',
      type: 'date',
      isClearable: true,
    },
    {
      label: 'common:label.endDate',
      name: 'endDate',
      type: 'date',
      isClearable: true,
    },
  ];

  btnSpan = 'col-md-12';
}

PaymentsSearchForm.propTypes = {
  onSubmit: PropTypes.func,
  isSubmitting: PropTypes.bool,
};

PaymentsSearchForm.defaultProps = {
  isSubmitting: false,
};

export default withTranslation('common')(PaymentsSearchForm);